import './App.css';
import Dashboard from './pages/dashboard/dashboard';

function App() {
  return (
    <div style={{ height: '100vh' }}>
      <Dashboard />
    </div>
  );
}

export default App;
